import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const propertyManagerApi = createApi({
    reducerPath: "propertyManagerApi",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["Appfolio"],
    endpoints: (builder) => ({
        getPropertyManagerData: builder.query({
            query: ({ page = 1, limit = 25, search = "" }) => `/property-managers?page=${page}&limit=${limit}&search=${search}`,
            providesTags: ["Appfolio"],
        }),

        savePropertyManager: builder.mutation({
            query: (payload) => ({
                url: `/property-managers`,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["Appfolio"],
        }),
        updatePropertyManager: builder.mutation({
            query: ({ id, data }) => ({
                url: `/property-managers/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Appfolio"],
        }),

        deletePropertyManager: builder.mutation({
            query: (id) => ({
                url: `/property-managers/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Appfolio"],
        }),
    }),
});

export const {
    useGetPropertyManagerDataQuery,
    useSavePropertyManagerMutation,
    useUpdatePropertyManagerMutation,
    useDeletePropertyManagerMutation,
} = propertyManagerApi;
